export function accordionOpenFromSearch() {
  //  When navigating to a page from the search results
  //  If the target component is inside an accordion
  //  Open the accordion automoatically so the content is visible

  //  Get target element ID from the URL
  //  This will be the ID paragraph component, not the accordion within it
  const targetElementID = window.location.href.split('#')[1];
  const targetElement = document.getElementById(targetElementID);

  if (targetElement) {
    if (targetElement.parentElement.classList.contains('is-accordion')) {
      targetElement.closest('.accordion_link__container').classList.toggle('show');
      targetElement.closest('.accordion_link__container').querySelector('.accordion_link__header').setAttribute('aria-expanded', 'true');
    } else {
      const container = targetElement.querySelector('.accordion_link__container');
      if (container) {
        container.classList.toggle('show');
        container.querySelector('.accordion_link__header').setAttribute('aria-expanded', 'true');
      }
    }
  }
}

export default accordionOpenFromSearch;
